import { ixlBranding, rsBranding, social } from "@resourcehub/resourcehub-assets";
import footerIxlLogo from "../../../../global/footer.ixl-logo";
import footerRsLogo from "../../../../global/footer.rs-logo";

export default ({ strings }) => ({
    cta: {
        visible: true,
        contact_modal: true,
        email_capture: false,

        market: "de",
        domain: ".de",
        vertical: "k12",
        page: "home",

        // Strings
        main_label: strings.footer_cta_pricing_label,
        sub_label: null,
        button_label: strings.footer_cta_pricing_button,
        form_title: strings.footer_cta_pricing_title,
        form_subtitle: strings.footer_cta_pricing_subtitle,

        form_firstname: strings.footer_cta_form_firstname,
        form_lastname: strings.footer_cta_form_lastname,
        form_email: strings.footer_cta_form_email,
        form_phone: strings.footer_cta_form_phone,
        form_country: strings.footer_cta_form_country,

        form_organization: strings.footer_cta_form_organization,
        form_organizationsize_100: strings.footer_cta_form_organizationsize_100,
        form_organizationsize_500: strings.footer_cta_form_organizationsize_500,
        form_organizationsize_1000: strings.footer_cta_form_organizationsize_1000,
        form_organizationsize_5000: strings.footer_cta_form_organizationsize_5000,
        form_organizationsize_10000: strings.footer_cta_form_organizationsize_10000,
        form_organizationsize_25000: strings.footer_cta_form_organizationsize_25000,
        form_organizationsize_50000: strings.footer_cta_form_organizationsize_50000,
        form_organizationsize_more: strings.footer_cta_form_organizationsize_more,
        form_organizationsize: strings.footer_cta_form_organizationsize,

        form_role: strings.footer_cta_form_role,
        form_role_individualcontributor: strings.footer_cta_form_role_individualcontributor,
        form_role_manager: strings.footer_cta_form_role_manager,
        form_role_executive: strings.footer_cta_form_role_executive,
        form_role_vicepresident: strings.footer_cta_form_role_vicepresident,
        form_role_director: strings.footer_cta_form_role_director,
        form_role_teacher: strings.footer_cta_form_role_teacher,
        form_role_techcoordinator: strings.footer_cta_form_role_techcoordinator,
        form_role_curriculumdirector: strings.footer_cta_form_role_curriculumdirector,
        form_role_principal: strings.footer_cta_form_role_principal,
        form_role_boardmember: strings.footer_cta_form_role_boardmember,
        form_role_superintendent: strings.footer_cta_form_role_superintendent,
        form_comments: strings.footer_cta_form_comments,
        footer_opt_in_text_before_button: strings.footer_cta_opt_in_text_before_button,
        footer_opt_in_learn_more_button_text: strings.footer_cta_opt_in_learn_more_button_text,
        footer_opt_in_text_after_button: strings.footer_cta_opt_in_text_after_button,
        footer_opt_in_learn_more_text_1: strings.footer_cta_opt_in_learn_more_text_1,
        footer_opt_in_learn_more_link_text_1: strings.footer_cta_opt_in_learn_more_link_text_1,
        footer_opt_in_learn_more_text_2: strings.footer_cta_opt_in_learn_more_text_2,
        footer_opt_in_learn_more_text_3: strings.footer_cta_opt_in_learn_more_text_3,
        footer_opt_in_learn_more_privacyemail: strings.footer_cta_opt_in_learn_more_privacyemail,
        footer_opt_in_learn_more_privacyUrl: strings.footer_cta_opt_in_learn_more_privacyUrl,
        form_submit: strings.footer_cta_form_submit,
        form_pricing_thanks: strings.footer_cta_form_pricing_thanks
    },
    menu: {
        visible: true,
        sections: [
            {
                label: strings.footer_menu_products_label,
                links: [
                    {
                        visible: true,
                        destination: "https://www.rosettastone.de/",
                        external: true,
                        new_window: false,

                        // Labels
                        label: strings.footer_menu_products_consumer_label
                    },

                    {
                        visible: true,
                        destination: "https://www.rosettastone.de/bildung/",
                        external: true,
                        new_window: false,

                        // Labels
                        label: strings.footer_menu_products_education_primary_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.de/hochschulen/",
                        external: true,
                        new_window: true,

                        // Labels
                        label: strings.footer_menu_products_education_secondary_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.de/unternehmen/",
                        external: true,
                        new_window: false,

                        // Labels
                        label: strings.footer_menu_products_enterprise_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.de/oeffentlichersektor/",
                        external: true,
                        new_window: false,

                        // Labels
                        label: strings.footer_menu_products_publicsector_label
                    }
                ]
            },
            {
                label: strings.footer_menu_about_label,
                links: [
                    {
                        visible: true,
                        destination: "http://www.rosettastone.de/ueber-uns",
                        external: true,
                        new_window: true,

                        // Labels
                        label: strings.footer_menu_about_about_us_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.de/magazine",
                        external: true,
                        new_window: true,

                        // Labels
                        label: strings.footer_menu_about_blog_label
                    },
                    {
                        visible: true,
                        destination: "https://pr.rosettastone.com/",
                        external: true,
                        new_window: true,

                        // Labels
                        label: strings.footer_menu_about_press_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.com/careers/",
                        external: true,
                        new_window: true,

                        // Labels
                        label: strings.footer_menu_about_careers_label
                    },
                    {
                        visible: true,
                        destination: "http://www.rosettastone.de/kontakt/",
                        external: true,
                        new_window: true,

                        // Labels
                        label: strings.footer_menu_about_contact_label
                    }
                ]
            },
            {
                label: strings.footer_menu_support_label,
                links: [
                    {
                        visible: true,
                        destination: "https://support.rosettastone.com/de/work",
                        external: true,
                        new_window: true,

                        // Labels
                        label: strings.footer_menu_support_support_site_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.de/faq",
                        external: true,
                        new_window: true,

                        // Labels
                        label: strings.footer_menu_support_faqs_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.de/systemanforderungen",
                        external: true,
                        new_window: true,

                        // Labels
                        label: strings.footer_menu_support_system_requirements_label
                    }
                ]
            }
        ]
    },
    meta: {
        visible: true,
        copyright: {
            visible: true,
            label: strings.footer_meta_copyright_label,
            IXLLabel: strings.footer_meta_copyright_IXL,
            destination: "/"
        },
        ixl_logo: footerIxlLogo({ strings }),
        rs_logo: footerRsLogo({ strings }),
        ccpa: {
            visible: true,
            label: strings.footer_meta_ccpa_label,
            destination: "https://www.rosettastone.com/lp/ccpa"
        },
        cookieSettings: {
            visible: true,
            label: strings.footer_meta_cookie_settings_label,
            destination: "#"
        },
        agreements: {
            visible: true,
            label: strings.footer_meta_agreements_label,
            destination: "https://www.rosettastone.de/vereinbarungen"
        },
        termsConditions: {
            visible: true,
            label: strings.footer_meta_terms_conditions_label,
            destination: "https://www.rosettastone.de/nutzungsbedingungen"
        },
        privacyPolicy: {
            visible: true,
            label: strings.footer_meta_privacy_policy_label,
            destination: "https://resources.rosettastone.com/CDN/de/pdfs/website-privacy-policy-de.pdf"
        }
    },
    region_social: {
        visible: true,
        region: {
            visible: true,
            label: strings.footer_region_label,
            options: [
                {
                    destination: "https://www.rosettastone.com/",
                    label: strings.footer_region_options_us_label
                },
                {
                    destination: "https://espanol.rosettastone.com/",
                    label: strings.footer_region_options_la_label
                },
                {
                    destination: "https://www.therosettastone.com.au/",
                    label: strings.footer_region_options_au_label
                },
                {
                    destination: "https://pt.rosettaston.com/",
                    label: strings.footer_region_options_br_label
                },
                {
                    destination: "https://www.rosettastone.cn/",
                    label: strings.footer_region_options_cn_label
                },
                {
                    destination: "https://www.rosettastone.de/",
                    label: strings.footer_region_options_de_label
                },
                {
                    destination: "https://www.rosettastone.eu/",
                    label: strings.footer_region_options_eu_label
                },
                {
                    destination: "https://www.rosettastone.es/",
                    label: strings.footer_region_options_es_label
                },
                {
                    destination: "https://www.rosettastone.fr/",
                    label: strings.footer_region_options_fr_label
                },
                {
                    destination: "https://www.rosettastone.it/",
                    label: strings.footer_region_options_it_label
                },
                {
                    destination: "https://www.rosettastone.co.uk/",
                    label: strings.footer_region_options_uk_label
                },
                {
                    destination: "https://www.rosettastone.co.jp/",
                    label: strings.footer_region_options_jp_label
                },
                {
                    destination: "https://www.rosettastone.co.kr/",
                    label: strings.footer_region_options_kr_label
                }
            ]
        },
        social: {
            visible: true,
            label: strings.footer_social_label,
            options: [
                {
                    service: "facebook",
                    destination: "https://www.facebook.com/RosettaStoneDE",
                    image: social.facebookDarkSvg
                },
                {
                    service: "twitter",
                    destination: "https://twitter.com/rosettastone",
                    image: social.twitterDarkSvg
                },
                {
                    service: "instagram",
                    destination: "https://www.instagram.com/rosettastone",
                    image: social.instagramDarkSvg
                },
                {
                    service: "youtube",
                    destination: "https://www.youtube.com/user/rosettastoneDE",
                    image: social.youtubeDarkSvg
                }
            ]
        }
    }
});
